/* Auto-generated from 产品 Excel — do not edit by hand */
window.NAZIFA_SKU_SPECS = {
  "JX01Y": {
    "sku": "JX01Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "10.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "JX02Y": {
    "sku": "JX02Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Rice Bowl",
    "kind": "single",
    "dimensions": "14.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "JX03Y": {
    "sku": "JX03Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Noodle Bowl",
    "kind": "single",
    "dimensions": "20 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 46.0
  },
  "JX04Y": {
    "sku": "JX04Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 8.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 36.0
  },
  "JX05y": {
    "sku": "JX05y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Small Round Plate",
    "kind": "single",
    "dimensions": "24 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "JX06y": {
    "sku": "JX06y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "30 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "JX1005y": {
    "sku": "JX1005y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Kettle",
    "kind": "single",
    "dimensions": "5 × 20cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 106.0
  },
  "JX12": {
    "sku": "JX12",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Milk Tea Bowl",
    "kind": "single",
    "dimensions": "12 × 7.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "JX13JXy": {
    "sku": "JX13JXy",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Chopstick Holder",
    "kind": "single",
    "dimensions": "11.5 × 16.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 78.0
  },
  "JX13Y": {
    "sku": "JX13Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "15 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "JX15y": {
    "sku": "JX15y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Small Square Plate",
    "kind": "single",
    "dimensions": "20.5 × 3.5cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "JX16y": {
    "sku": "JX16y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Medium Square Plate",
    "kind": "single",
    "dimensions": "27 × 4cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "JX18-3pcsy": {
    "sku": "JX18-3pcsy",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Chili & Vinegar Set",
    "kind": "set",
    "dimensions": "5 × 12.5cm/28 × 11.5 × 2cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 109.0
  },
  "JX26Y": {
    "sku": "JX26Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Large Deep Plate",
    "kind": "single",
    "dimensions": "34.5 × 5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 138.0
  },
  "JX27Y": {
    "sku": "JX27Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Large Round Plate",
    "kind": "single",
    "dimensions": "36 × 3cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 115.0
  },
  "JX30Y": {
    "sku": "JX30Y",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Rectangular Platter",
    "kind": "single",
    "dimensions": "37 × 24 × 4cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 119.0
  },
  "JX39LXY": {
    "sku": "JX39LXY",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "6-Piece Cup & Saucer Set",
    "kind": "set",
    "dimensions": "8 × 7cm/14 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 240.0
  },
  "JX40Y4": {
    "sku": "JX40Y4",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Mug Set (4)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "4",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 118.0
  },
  "JX40Y6": {
    "sku": "JX40Y6",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Mug Set (6)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 178.0
  },
  "JX466XY": {
    "sku": "JX466XY",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Hot Pot Bowl",
    "kind": "single",
    "dimensions": "27 × 8.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 126.0
  },
  "JX90TY": {
    "sku": "JX90TY",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "Seasoning Jar Set (3)",
    "kind": "set",
    "dimensions": "7.5 × 18cm",
    "pack": "3",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 268.0
  },
  "JX999": {
    "sku": "JX999",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "50-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1700.0
  },
  "JX887": {
    "sku": "JX887",
    "series": "Sumruh",
    "series_zh": "凤凰花",
    "title": "14-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1800.0
  },
  "JH01": {
    "sku": "JH01",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "10.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "JH02Y": {
    "sku": "JH02Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Rice Bowl",
    "kind": "single",
    "dimensions": "14.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "JH03Y": {
    "sku": "JH03Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Noodle Bowl",
    "kind": "single",
    "dimensions": "20 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 46.0
  },
  "JH04Y": {
    "sku": "JH04Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 8.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 36.0
  },
  "JH05y": {
    "sku": "JH05y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Small Round Plate",
    "kind": "single",
    "dimensions": "24 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "JH06y": {
    "sku": "JH06y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "30 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "JH1005y": {
    "sku": "JH1005y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "5 × 20cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 106.0
  },
  "JH12": {
    "sku": "JH12",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Milk Tea Bowl",
    "kind": "single",
    "dimensions": "12 × 7.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "JH13jxy": {
    "sku": "JH13jxy",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Chopstick Holder",
    "kind": "single",
    "dimensions": "11.5 × 16.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 78.0
  },
  "JH13Y": {
    "sku": "JH13Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "15 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "JH15y": {
    "sku": "JH15y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Small Square Plate",
    "kind": "single",
    "dimensions": "20.5 × 3.5cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "JH16y": {
    "sku": "JH16y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Medium Square Plate",
    "kind": "single",
    "dimensions": "27 × 4cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "JH18-3pcsy": {
    "sku": "JH18-3pcsy",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Chili & Vinegar Set",
    "kind": "set",
    "dimensions": "5 × 12.5cm/28 × 11.5 × 2cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 109.0
  },
  "JH26Y": {
    "sku": "JH26Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Large Deep Plate",
    "kind": "single",
    "dimensions": "34.5 × 5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 138.0
  },
  "JH27Y": {
    "sku": "JH27Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Large Round Plate",
    "kind": "single",
    "dimensions": "36 × 3cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 115.0
  },
  "JH30Y": {
    "sku": "JH30Y",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Rectangular Platter",
    "kind": "single",
    "dimensions": "37 × 24 × 4cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 119.0
  },
  "JH39LXy": {
    "sku": "JH39LXy",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "6-Piece Cup & Saucer Set",
    "kind": "set",
    "dimensions": "8 × 7cm/14 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 240.0
  },
  "JH40Y4": {
    "sku": "JH40Y4",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Mug Set (4)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "4",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 118.0
  },
  "JH40Y6": {
    "sku": "JH40Y6",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Mug Set (6)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 178.0
  },
  "JH466XY": {
    "sku": "JH466XY",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Hot Pot Bowl",
    "kind": "single",
    "dimensions": "27 × 8.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 126.0
  },
  "JH90TY": {
    "sku": "JH90TY",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "Seasoning Jar Set (3)",
    "kind": "set",
    "dimensions": "7.5 × 18cm",
    "pack": "3",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 268.0
  },
  "JH888": {
    "sku": "JH888",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "14-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1700.0
  },
  "JH999": {
    "sku": "JH999",
    "series": "Kuyax",
    "series_zh": "太阳花",
    "title": "50-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1800.0
  },
  "QR01Y": {
    "sku": "QR01Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "10.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "QR02Y": {
    "sku": "QR02Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Rice Bowl",
    "kind": "single",
    "dimensions": "14.5 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "QR03Y": {
    "sku": "QR03Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Noodle Bowl",
    "kind": "single",
    "dimensions": "20 × 6cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 46.0
  },
  "QR04Y": {
    "sku": "QR04Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 8.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 36.0
  },
  "QR05y": {
    "sku": "QR05y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Small Round Plate",
    "kind": "single",
    "dimensions": "24 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "QR06y": {
    "sku": "QR06y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "30 × 3cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "QR1005y": {
    "sku": "QR1005y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "5 × 20cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 106.0
  },
  "QR12": {
    "sku": "QR12",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Milk Tea Bowl",
    "kind": "single",
    "dimensions": "12 × 7.5cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 30.0
  },
  "QR13jxy": {
    "sku": "QR13jxy",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Chopstick Holder",
    "kind": "single",
    "dimensions": "11.5 × 16.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 78.0
  },
  "QR13Y": {
    "sku": "QR13Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "15 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 26.0
  },
  "QR15y": {
    "sku": "QR15y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Small Square Plate",
    "kind": "single",
    "dimensions": "20.5 × 3.5cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 66.0
  },
  "QR16y": {
    "sku": "QR16y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Medium Square Plate",
    "kind": "single",
    "dimensions": "27 × 4cm",
    "pack": "2",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 86.0
  },
  "QR18-3pcsy": {
    "sku": "QR18-3pcsy",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Chili & Vinegar Set",
    "kind": "set",
    "dimensions": "5 × 12.5cm/28 × 11.5 × 2cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 109.0
  },
  "QR26Y": {
    "sku": "QR26Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Large Deep Plate",
    "kind": "single",
    "dimensions": "34.5 × 5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 138.0
  },
  "QR27Y": {
    "sku": "QR27Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Large Round Plate",
    "kind": "single",
    "dimensions": "36 × 3cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 115.0
  },
  "QR30Y": {
    "sku": "QR30Y",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Rectangular Platter",
    "kind": "single",
    "dimensions": "37 × 24 × 4cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 119.0
  },
  "QR39LXy": {
    "sku": "QR39LXy",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "6-Piece Cup & Saucer Set",
    "kind": "set",
    "dimensions": "8 × 7cm/14 × 3cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 240.0
  },
  "QR40Y6": {
    "sku": "QR40Y6",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Mug Set (6)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "4",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 118.0
  },
  "QR40Y4": {
    "sku": "QR40Y4",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Mug Set (4)",
    "kind": "set",
    "dimensions": "8 × 9cm",
    "pack": "6",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 178.0
  },
  "QR466XY": {
    "sku": "QR466XY",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Hot Pot Bowl",
    "kind": "single",
    "dimensions": "27 × 8.5cm",
    "pack": "1",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": true,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 126.0
  },
  "QR90TY": {
    "sku": "QR90TY",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "Seasoning Jar Set (3)",
    "kind": "set",
    "dimensions": "7.5 × 18cm",
    "pack": "3",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 268.0
  },
  "QR999": {
    "sku": "QR999",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "50-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1800.0
  },
  "QR887": {
    "sku": "QR887",
    "series": "Badam",
    "series_zh": "巴旦木花",
    "title": "14-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Underglaze transfer",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": true,
    "oven": true,
    "dishwasher": false,
    "care_note": "Microwave & oven OK for most transfer pieces; avoid thermal shock.",
    "retail_cny": 1700.0
  },
  "Anar01": {
    "sku": "Anar01",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "11 × 11 × 6cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 49.0
  },
  "Anar02": {
    "sku": "Anar02",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Noodle Plate",
    "kind": "single",
    "dimensions": "21 × 21 × 3.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 168.0
  },
  "Anar03": {
    "sku": "Anar03",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 15 × 7.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 69.0
  },
  "Anar04": {
    "sku": "Anar04",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "25 × 25 × 4cm",
    "pack": "2个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 189.0
  },
  "Anar05": {
    "sku": "Anar05",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "16 × 16 × 1.8cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 55.0
  },
  "Anar06": {
    "sku": "Anar06",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "25 × 14 × 23cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 498.0
  },
  "Anar07": {
    "sku": "Anar07",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Deep Plate",
    "kind": "single",
    "dimensions": "30.5 × 30.5 × 5cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 269.0
  },
  "Anar08": {
    "sku": "Anar08",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "Cup & Saucer Gift Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "8个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 468.0
  },
  "Anar-Ash": {
    "sku": "Anar-Ash",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "58-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 5500.0
  },
  "Anar-Joza": {
    "sku": "Anar-Joza",
    "series": "Anar",
    "series_zh": "石榴花",
    "title": "14-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 3900.0
  },
  "ZIBA01(G)": {
    "sku": "ZIBA01(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "11 × 11 × 6cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "ZIBA02(G)": {
    "sku": "ZIBA02(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 15 × 7.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 52.0
  },
  "ZIBA03(G)": {
    "sku": "ZIBA03(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "16 × 16 × 1.8cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "ZIBA04(G)": {
    "sku": "ZIBA04(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "25 × 25 × 4cm",
    "pack": "2个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 168.0
  },
  "ZIBA05(G)": {
    "sku": "ZIBA05(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "25 × 14 × 23cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 299.0
  },
  "ZIBA06(G)": {
    "sku": "ZIBA06(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Deep Plate",
    "kind": "single",
    "dimensions": "30.5 × 30.5 × 5cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 198.0
  },
  "ZIBA07(G)": {
    "sku": "ZIBA07(G)",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "Noodle Plate",
    "kind": "single",
    "dimensions": "21 × 21 × 3.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 128.0
  },
  "ZIBA(G)-Ash": {
    "sku": "ZIBA(G)-Ash",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "58-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 3900.0
  },
  "ZIBA(G)-Joza": {
    "sku": "ZIBA(G)-Joza",
    "series": "Ziba Green",
    "series_zh": "孜巴绿",
    "title": "13-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 2600.0
  },
  "ZIBA01(B)": {
    "sku": "ZIBA01(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "11 × 11 × 6cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "ZIBA02(B)": {
    "sku": "ZIBA02(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 15 × 7.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 52.0
  },
  "ZIBA03(B)": {
    "sku": "ZIBA03(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "16 × 16 × 1.8cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "ZIBA04(B)": {
    "sku": "ZIBA04(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "25 × 25 × 4cm",
    "pack": "2个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 168.0
  },
  "ZIBA05(B)": {
    "sku": "ZIBA05(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "25 × 14 × 23cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 299.0
  },
  "ZIBA06(B)": {
    "sku": "ZIBA06(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Deep Plate",
    "kind": "single",
    "dimensions": "30.5 × 30.5 × 5cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 198.0
  },
  "ZIBA07(B)": {
    "sku": "ZIBA07(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Noodle Plate",
    "kind": "single",
    "dimensions": "21 × 21 × 3.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 128.0
  },
  "ZIBA08(B)": {
    "sku": "ZIBA08(B)",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "Cup & Saucer Gift Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "4个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 368.0
  },
  "ZIBA(B)-Ash": {
    "sku": "ZIBA(B)-Ash",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "58-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 3900.0
  },
  "ZIBA(B)-Joza": {
    "sku": "ZIBA(B)-Joza",
    "series": "Ziba Blue",
    "series_zh": "孜巴蓝",
    "title": "13-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 2600.0
  },
  "Tannaz01": {
    "sku": "Tannaz01",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Small Bowl",
    "kind": "single",
    "dimensions": "11 × 11 × 6cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "Tannaz02": {
    "sku": "Tannaz02",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Deep Bowl",
    "kind": "single",
    "dimensions": "15 × 15 × 7.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 52.0
  },
  "Tannaz03": {
    "sku": "Tannaz03",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Dumpling Plate",
    "kind": "single",
    "dimensions": "16 × 16 × 1.8cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 42.0
  },
  "Tannaz04": {
    "sku": "Tannaz04",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Medium Round Plate",
    "kind": "single",
    "dimensions": "25 × 25 × 4cm",
    "pack": "2个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 168.0
  },
  "Tannaz05": {
    "sku": "Tannaz05",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Teapot",
    "kind": "single",
    "dimensions": "25 × 14 × 23cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 299.0
  },
  "Tannaz06": {
    "sku": "Tannaz06",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Deep Plate",
    "kind": "single",
    "dimensions": "30.5 × 30.5 × 5cm",
    "pack": "1个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 198.0
  },
  "Tannaz07": {
    "sku": "Tannaz07",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Noodle Plate",
    "kind": "single",
    "dimensions": "21 × 21 × 3.5cm",
    "pack": "6个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 128.0
  },
  "Tannaz08": {
    "sku": "Tannaz08",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "Cup & Saucer Gift Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "8个/盒",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 368.0
  },
  "Tannaz-Ash": {
    "sku": "Tannaz-Ash",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "58-Piece Dinnerware Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 3900.0
  },
  "Tannaz-Joza": {
    "sku": "Tannaz-Joza",
    "series": "Tannaz",
    "series_zh": "谭娜孜",
    "title": "13-Piece Fruit Bowl Set",
    "kind": "set",
    "dimensions": "/",
    "pack": "/",
    "craft": "Hand-painted underglaze",
    "material": "Ceramic",
    "glaze": "Clear glaze",
    "microwave": false,
    "oven": true,
    "dishwasher": false,
    "care_note": "Hand wash recommended for painted / gold accents. Oven up to 200°C where noted.",
    "retail_cny": 2600.0
  }
};
